/////////////////////////////////////////////////////////////
import { useCustomSelector } from '@/core/redux/hooks';

export const Energy: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/

	/*********************
	// #region Redux
	**********************/
	const { max_energy, current_energy } = useCustomSelector(
		(state) => state.counter
	);

	/*********************
	// #region States
	**********************/

	/*********************
	// #region Functions  
	**********************/

	/*********************
	// #region Template
	**********************/
	return (
		<div>
			<div
				className={`flex flex-col items-center p-2 gap-2 rounded-[20px] flex-1`}
			>
				<img
					className="drop-shadow-lg"
					src={process.env.VITE_ENERGY_IMAGE}
					width={'45px'}
					height={'45px'}
				/>
			</div>
			<p className="text-xs font-semibold">
				{current_energy}/{max_energy}
			</p>
		</div>
	);
};
